export default function RelayBadge({ relay }) {
  if (relay === "on" || relay === true) {
    return <span className="badge-ok">⚡ on</span>;
  }
  if (relay === "off" || relay === false) {
    return <span className="badge-muted">○ off</span>;
  }
  return <span className="badge-muted">—</span>;
}
